<template>
  <b-card title="پرداخت‌های درگاه">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="هدف"
                  label-for="Purpose"
                >
                  <v-select
                    v-model="filterOptions.Purpose"
                    :options="purposeOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="درگاه"
                  label-for="Gateway"
                >
                  <v-select
                    v-model="filterOptions.Gateway"
                    :options="gatewayOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          show-empty
          empty-text="پرداختی یافت نشد"
        >
          <template #cell(User)="data">
            <span>{{ ((data.item.UserName || '') + ' ' + (data.item.UserFamily || '')).trim() || '—' }}</span>
          </template>

          <template #cell(Amount)="data">
            <span class="text-nowrap font-weight-bold">{{ money(data.value) }}</span>
          </template>

          <template #cell(Purpose)="data">
            <b-badge variant="light-secondary">
              {{ purposeText(data.value) }}
            </b-badge>
          </template>

          <template #cell(Gateway)="data">
            <span>{{ gatewayText(data.value) }}</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">
              {{ statusText(data.value) }}
            </b-badge>
          </template>

          <template #cell(RefId)="data">
            <span class="text-nowrap">{{ data.value || '—' }}</span>
          </template>

          <template #cell(CreatedAt)="data">
            <span class="text-nowrap">{{ data.value | date('date-time') }}</span>
          </template>

          <template #cell(PaidAt)="data">
            <span class="text-nowrap">{{ data.value ? $options.filters.date(data.value, 'date-time') : '—' }}</span>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Payment',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Mobile: null,
        Purpose: null,
        Status: null,
        Gateway: null,
        Page: 1,
        PerPage: 10,
      },
      purposeOptions: [
        { text: 'شارژ کیف‌پول', value: 0 },
        { text: 'پرداخت رزرو', value: 1 },
        { text: 'نردبان آگهی', value: 2 },
        { text: 'نردبان ترخیص‌کار', value: 3 },
        { text: 'نردبان بازرگان', value: 4 },
        { text: 'نردبان مشاوره', value: 5 },
      ],
      statusOptions: [
        { text: 'در انتظار', value: 0 },
        { text: 'موفق', value: 1 },
        { text: 'ناموفق', value: 2 },
      ],
      gatewayOptions: [
        { text: 'زرین‌پال', value: 0 },
        { text: 'درگاه دوم', value: 1 },
      ],
      items: [],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'User', label: 'کاربر' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'Amount', label: 'مبلغ (تومان)' },
        { key: 'Purpose', label: 'هدف' },
        { key: 'Gateway', label: 'درگاه' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'RefId', label: 'کد پیگیری' },
        { key: 'CreatedAt', label: 'تاریخ ایجاد' },
        { key: 'PaidAt', label: 'تاریخ پرداخت' },
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    purposeText(value) {
      const item = this.purposeOptions.find(x => x.value === value)
      return item ? item.text : '—'
    },
    gatewayText(value) {
      const item = this.gatewayOptions.find(x => x.value === value)
      return item ? item.text : '—'
    },
    statusText(value) {
      return ['در انتظار', 'موفق', 'ناموفق'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-success', 'light-danger'][value] || 'light-secondary'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.payment.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
